import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';

import { BlcsComponent } from './detail/surveys/blcs/blcs.component';
import { BwcsComponent } from './detail/surveys/bwcs/bwcs.component';
import { CognitionComponent } from './detail/tests/cognition/cognition.component';
import { DetailComponent } from './detail/detail.component';
import { DetailInfoComponent } from './detail/detail-info/detail-info.component';
import { DexterityComponent } from './detail/tests/dexterity/dexterity.component';
import { EnduranceComponent } from './detail/tests/endurance/endurance.component';
import { InformationComponent } from './detail/detail-info/information/information.component';
import { ListComponent } from './list/list.component';
import { MedicalComponent } from './detail/detail-info/medical/medical.component';
import { Mfis5Component } from './detail/surveys/mfis5/mfis5.component';
import { OverviewComponent } from './detail/overview/overview.component';
import { PatientsRoutingModule } from './patients-routing.module';
import { PerimeterComponent } from './detail/tests/perimeter/perimeter.component';
import { Phq8Component } from './detail/surveys/phq8/phq8.component';
import { PsComponent } from './detail/surveys/ps/ps.component';
import { Sf36Component } from './detail/surveys/sf36/sf36.component';
import { SharedModule } from '../shared/shared.module';
import { SurveysComponent } from './detail/overview/surveys/surveys.component';
import { TestsComponent } from './detail/overview/tests/tests.component';
import { VisionComponent } from './detail/tests/vision/vision.component';

@NgModule({
  declarations: [
    ListComponent,
    DetailComponent,
    DetailInfoComponent,
    InformationComponent,
    MedicalComponent,
    OverviewComponent,
    PerimeterComponent,
    EnduranceComponent,
    VisionComponent,
    DexterityComponent,
    CognitionComponent,
    TestsComponent,
    SurveysComponent,
    BlcsComponent,
    BwcsComponent,
    Mfis5Component,
    Phq8Component,
    PsComponent,
    Sf36Component,
  ],
  imports: [CommonModule, PatientsRoutingModule, SharedModule],
})
export class PatientsModule {}
